module.exports = __webpack_public_path__ + "img/s31.28003fa7.svg";